import axiosIns from 'utils/axios'

let epmcore = 'EPM-CORE-SERVICE'
import {funMenu, funProjectAuthority} from "utils/common";

export function getAvailableCompanyList() {
  return axiosIns({
    url: `/api/pc/employee/getAvailableCompanyList`,
    owner: epmcore,
    method: 'put'
  })
}

export function changeLoginCompany(companyId) {
  return axiosIns({
    url: `/api/pc/employee/changeLoginCompany/${companyId}`,
    owner: epmcore,
    method: 'put'
  }).then(res => {

    if (res.code === 1000) {
      let menuData = []
      let authority = funMenu(res.data.platformPermissionVOList, "0", menuData)

      res.data.sysPermissionList = authority[0]
      res.data.functionAuthority = authority[1]
      let authorityData = []
      res.data.projectAuthority = null
      if (res.data.projectPermissionVOList)
        res.data.projectAuthority = funProjectAuthority(res.data.projectPermissionVOList, authorityData)
      // res.data.functionAuthority = funFunctionAuthority(res.data.platformPermissionVOList,authorityData)

    }
    return Promise.resolve(res)
  }).catch(err => {
    return Promise.reject(err)
  })
}

/**
 * 获取待审核事项数量
 */
export function getNeedCheckNum() {
  return axiosIns({
    url: '/api/pc/projectMemberVerify/needVerifyCount',
    owner: epmcore,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/views/layout/layoutAPI.js